import { Link } from "react-router-dom";
import { Smartphone, Globe, BookOpen } from "lucide-react";
import { PLAY_URLS } from "@/lib/playLinks";
import { usePages } from "@/lib/i18nPages";
import { useLang } from "@/lib/i18n";
import { getGuide } from "@/lib/userGuide";

const DOMAINS = [
  { name: "KashAssist.com", href: "https://kashassist.com", testid: "footer-link-kashassist" },
  { name: "KashPadhaiAssist.com", href: null, soon: true, testid: "footer-link-kashpatshala" },
];

export default function SiteFooter({ brand = "KashAssist" }) {
  const F = usePages().footer;
  const playUrl = PLAY_URLS.kirana;
  const GU = getGuide(useLang().lang).ui;
  return (
    <footer className="bg-[#111827] text-white/60 text-sm">
      <div className="max-w-6xl mx-auto px-6 py-12 grid grid-cols-1 md:grid-cols-3 gap-8">
        <div>
          <p data-testid="footer-brand" className="text-white font-heading font-bold text-base mb-2">{brand}</p>
          <a href="https://kashsam.ai" target="_blank" rel="noopener noreferrer" data-testid="footer-kashsam-logo-link" title="Kashsam Data Solutions">
            <img
              src="/kashsam-logo.webp"
              alt="Kashsam Data Solutions — Encash your data"
              data-testid="footer-kashsam-logo"
              className="h-14 w-auto mb-3 invert opacity-80 hover:opacity-100 transition-opacity duration-150"
            />
          </a>
          <p>{F.byLine}</p>
          <Link to="/privacy" data-testid="footer-privacy-link" className="underline hover:text-white inline-block mt-2">
            {F.privacy}
          </Link>
        </div>
        <div>
          <p className="text-white/90 font-semibold mb-2 flex items-center gap-1.5"><Globe size={14} /> {F.websites}</p>
          <ul className="space-y-1.5">
            {DOMAINS.map((d) => (
              <li key={d.name}>
                {d.soon ? (
                  <span data-testid={d.testid} className="text-white/40">{d.name} <span className="text-[10px] uppercase tracking-wide border border-white/20 rounded-full px-2 py-0.5 ml-1">Coming soon</span></span>
                ) : (
                  <a data-testid={d.testid} href={d.href} className="hover:text-white underline underline-offset-2">{d.name}</a>
                )}
              </li>
            ))}
          </ul>
        </div>
        <div>
          <p className="text-white/90 font-semibold mb-2 flex items-center gap-1.5"><Smartphone size={14} /> {F.apps}</p>
          <a data-testid="footer-play-badge" href={playUrl} target="_blank" rel="noopener noreferrer" title={F.playGet}
            className="inline-block hover:-translate-y-0.5 transition-transform duration-150">
            <img src="/badges/google-play.png" alt="Get it on Google Play" width="564" height="168" className="h-11 w-auto" />
          </a>
          <p data-testid="footer-ios-hint" className="mt-3 text-xs">{GU.ios}</p>
          <Link to="/guide" data-testid="footer-guide-link" className="mt-3 inline-flex items-center gap-1.5 text-white font-semibold underline underline-offset-2 hover:text-[#FFC107]">
            <BookOpen size={13} /> {GU.title}
          </Link>
        </div>
      </div>
    </footer>
  );
}
